function Skeleton({ type }) {
    return (
        <div className={`skeleton --${type}`}></div>
    )
}
export default Skeleton